import { render } from "./SingleStatistic.vue?vue&type=template&id=ba06dd7e"
import script from "./SingleStatistic.vue?vue&type=script&lang=js"
export * from "./SingleStatistic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__